import React, { Component ,Fragment} from 'react';

export class FlowDataEntry extends Component {
    render() {
        const { children } = this.props;
        const saveTitle = this.props.saveTitle ? this.props.saveTitle : "Save"
        return (
            <Fragment>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header" >                                    
                            <div className="pull-right">
                                <button type="submit" className="btn btn-primary" >{saveTitle}</button>
                            </div>
                        </div>
                        <div className="card-body" >
                            {Array.isArray(children) ? children.map((item, index) =>
                            <Fragment key={index}>
                                {item}
                                <hr />
                            </Fragment>
                            ): 
                            <Fragment>
                                {children}
                            </Fragment>
                            }                           
                        </div>
                        <div className="card-footer">
                            <div className="pull-right">
                                <button type="submit" className="btn btn-primary" >{saveTitle}</button>
                            </div>
                        </div>
                    </div>       
                </div>
            </Fragment>
        )
    }
}

export default FlowDataEntry

